export default __webpack_public_path__ + "static/media/assignments-icon.37ad7744.png";